import {Injectable} from "@angular/core";
import {ApiHandlerService} from "../api-handler.service";
import {API_ENDPOINTS, API_URL} from "../../shared/utils/globals";
import {lastValueFrom} from "rxjs";
import {UpdatePortalEstimateDTO, UpdateSelectionOptionDTO} from "src/app/shared/interfaces/estimate/estimate.interface";
import {ApiBaseResponse} from "src/app/shared/interfaces/api-base-response.interface";
import {portalUrlDetailsQuery, previewLanguage, shareLinkWriteRefusal} from "./share-link-request";
import {PreviewTokenService} from "./preview-token.service";
import {LogRocketService} from "../logrocket-service/logrocket.service";

@Injectable({
  providedIn: 'root'
})
export class PortalUrlService {
  constructor(private apiService: ApiHandlerService, private logRocket: LogRocketService, private previewTokens: PreviewTokenService) {
  }

  Get(id: string, sendNotification: boolean) {
    if (!id) return;
    return lastValueFrom(this.apiService.Get(API_URL + API_ENDPOINTS.getPortalUrlDetails + portalUrlDetailsQuery(id, sendNotification)));
  }

  getInvoicePayments(id: string, invId: string) {
    if (!id) return;
    return lastValueFrom(this.apiService.Get(API_URL + API_ENDPOINTS.getInvoicePayments + "?id=" + id + "&invId=" + invId));
  }

  getUpdatedDateOfEntity(id: string) {
    if (!id) return;
    return lastValueFrom(this.apiService.Get(API_URL + API_ENDPOINTS.getUpdatedDateOfEntity + "?id=" + id));
  }

  updatePortalEstimate(body: UpdatePortalEstimateDTO): Promise<ApiBaseResponse> {
    return this.answer(API_ENDPOINTS.updatePortalEstimate, body);
  }

  UpdateSelectionOption(body: UpdateSelectionOptionDTO): Promise<ApiBaseResponse> {
    return this.answer(API_ENDPOINTS.updateSelectionOption, body);
  }

  /** A customer's answer on the shared document; a refusal comes back as a failed response the page can show. */
  private async answer(endpoint: string, body: unknown): Promise<ApiBaseResponse> {
    try {
      return await lastValueFrom(this.apiService.Post(API_URL + endpoint, body));
    } catch (error) {
      this.logRocket.captureMessage('A share link answer was refused', { endpoint, error: String(error) });
      return shareLinkWriteRefusal(error, this.previewTokens.token, previewLanguage(window.location.hash, navigator.language));
    }
  }
}
